import { Tabs } from '@mantine/core'
import { IconChartBar, IconCreditCard, IconWallet } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { Screen } from '@/components/Screen'
import { useGlobalState } from '@/hooks/useGlobalState'
import { FREE_PLAN_PRICE } from '@/utils/onboardingConstants'

import { PaymentTab } from './PaymentTab'
import { UsageTab } from './UsageTab'

export function BillingScreen() {
  const { api } = useGlobalState()

  const plansQuery = useQuery({
    queryKey: ['plans'],
    queryFn: () => api.getPlans(),
  })

  // Filter out free plan for billing screen (free plan is only for onboarding)
  const availablePlans = useMemo(() => {
    return plansQuery.data?.filter(plan => plan.priceDollars !== FREE_PLAN_PRICE) || []
  }, [plansQuery.data])

  return (
    <Screen title="Account Management" icon={IconCreditCard}>
      <Tabs defaultValue="payment">
        <Tabs.List>
          <Tabs.Tab value="payment" leftSection={<IconWallet size={16} />}>
            Billing
          </Tabs.Tab>
          <Tabs.Tab value="usage" leftSection={<IconChartBar size={16} />}>
            Usage
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="payment" pt="xl">
          {/* Payment Information */}
          <PaymentTab availablePlans={availablePlans} />
        </Tabs.Panel>

        <Tabs.Panel value="usage" pt="xl">
          <UsageTab />
        </Tabs.Panel>
      </Tabs>
    </Screen>
  )
}
